import { CampaignEvent, CalendarChannel } from 'src/features/MM/types';

export const mockChannels: CalendarChannel[] = [
  { id: 'channel-1', name: 'Channel 1' },
  { id: 'channel-2', name: 'Channel 2' },
  { id: 'channel-3', name: 'Channel 3' },
  { id: 'channel-4', name: 'Channel 4' },
  { id: 'channel-5', name: 'Channel 5' },
  { id: 'channel-6', name: 'Channel 6' },
  { id: 'channel-7', name: 'Channel 7' },
  { id: 'channel-8', name: 'Channel 8' },
  { id: 'channel-9', name: 'Channel 9' },
  { id: 'channel-10', name: 'Channel 10' },
];

export const mockEvents: CampaignEvent[] = [
  // Channel 1 - High intensity campaign with competitor from Aug 3 to Aug 7
  {
    id: 'campaign-1-1',
    name: 'Campaign 1',
    startDate: '2026-08-03',
    endDate: '2026-08-04',
    intensity: 'high',
    type: 'campaign',
    channel: 'channel-1',
  },
  {
    id: 'competitor-1-1',
    name: 'Competitor 1',
    startDate: '2026-08-03',
    endDate: '2026-08-04',
    intensity: 'medium',
    type: 'competitor',
    channel: 'channel-1',
  },

  // Channel 2 - Very light green campaign on Aug 3
  {
    id: 'campaign-2-1',
    name: 'Campaign 2',
    startDate: '2026-08-03',
    endDate: '2026-08-03',
    intensity: 'low',
    type: 'campaign',
    channel: 'channel-2',
  },
  // Channel 2 - Medium green campaign with competitor from Aug 5 to Aug 7
  {
    id: 'campaign-2-2',
    name: 'Campaign 2b',
    startDate: '2026-08-05',
    endDate: '2026-08-07',
    intensity: 'medium',
    type: 'campaign',
    channel: 'channel-2',
  },
  {
    id: 'competitor-2-1',
    name: 'Competitor 2',
    startDate: '2026-08-05',
    endDate: '2026-08-07',
    intensity: 'medium',
    type: 'competitor',
    channel: 'channel-2',
  },
  // Channel 2 - Light green campaign on Aug 10
  {
    id: 'campaign-2-3',
    name: 'Campaign 2c',
    startDate: '2026-08-10',
    endDate: '2026-08-10',
    intensity: 'low',
    type: 'campaign',
    channel: 'channel-2',
  },

  // Channel 3 - Light green campaign from Aug 6 to Aug 7
  {
    id: 'campaign-3-1',
    name: 'Campaign 3',
    startDate: '2026-08-06',
    endDate: '2026-08-07',
    intensity: 'low',
    type: 'campaign',
    channel: 'channel-3',
  },

  // Channel 4 - Medium green campaign with competitor from Aug 5 to Aug 7
  {
    id: 'campaign-4-1',
    name: 'Campaign 4',
    startDate: '2026-08-05',
    endDate: '2026-08-06',
    intensity: 'medium',
    type: 'campaign',
    channel: 'channel-4',
  },
  {
    id: 'competitor-4-1',
    name: 'Competitor 4',
    startDate: '2026-08-05',
    endDate: '2026-08-06',
    intensity: 'medium',
    type: 'competitor',
    channel: 'channel-4',
  },
  // Channel 4 - Light green campaign on Aug 7
  {
    id: 'campaign-4-2',
    name: 'Campaign 4b',
    startDate: '2026-08-07',
    endDate: '2026-08-07',
    intensity: 'low',
    type: 'campaign',
    channel: 'channel-4',
  },

  // Channel 5 - Light green campaign from Aug 3 to Aug 6
  {
    id: 'campaign-5-1',
    name: 'Campaign 5',
    startDate: '2026-08-03',
    endDate: '2026-08-04',
    intensity: 'low',
    type: 'campaign',
    channel: 'channel-5',
  },
  // Channel 5 - Medium green campaign from Aug 6 to Aug 7
  {
    id: 'campaign-5-2',
    name: 'Campaign 5b',
    startDate: '2026-08-06',
    endDate: '2026-08-06',
    intensity: 'medium',
    type: 'campaign',
    channel: 'channel-5',
  },
  // Channel 5 - Holiday on Aug 7
  {
    id: 'holiday-5-1',
    name: 'Holiday',
    startDate: '2026-08-07',
    endDate: '2026-08-07',
    intensity: 'high',
    type: 'holiday',
    channel: 'channel-5',
  },

  // Channel 6 - Dark green campaign from Aug 5 to Aug 6
  {
    id: 'campaign-6-1',
    name: 'Campaign 6',
    startDate: '2026-08-05',
    endDate: '2026-08-05',
    intensity: 'high',
    type: 'campaign',
    channel: 'channel-6',
  },
  // Channel 6 - Light green campaign from Aug 6 to Aug 7
  {
    id: 'campaign-6-2',
    name: 'Campaign 6b',
    startDate: '2026-08-06',
    endDate: '2026-08-07',
    intensity: 'low',
    type: 'campaign',
    channel: 'channel-6',
  },
  // Channel 6 - Competitor on Aug 7
  {
    id: 'competitor-6-1',
    name: 'Competitor 6',
    startDate: '2026-08-07',
    endDate: '2026-08-07',
    intensity: 'low',
    type: 'competitor',
    channel: 'channel-6',
  },

  // Channel 7 - Medium green campaign from Aug 3 to Aug 6
  {
    id: 'campaign-7-1',
    name: 'Campaign 7',
    startDate: '2026-08-03',
    endDate: '2026-08-06',
    intensity: 'medium',
    type: 'campaign',
    channel: 'channel-7',
  },
  // Channel 7 - Competitor from Aug 3 to Aug 4
  {
    id: 'competitor-7-1',
    name: 'Competitor 7',
    startDate: '2026-08-03',
    endDate: '2026-08-04',
    intensity: 'low',
    type: 'competitor',
    channel: 'channel-7',
  },

  // Channel 8 - Light green campaign from Aug 4 to Aug 6
  {
    id: 'campaign-8-1',
    name: 'Campaign 8',
    startDate: '2026-08-04',
    endDate: '2026-08-05',
    intensity: 'low',
    type: 'campaign',
    channel: 'channel-8',
  },
  // Channel 8 - Dark green campaign from Aug 6 to Aug 7
  {
    id: 'campaign-8-2',
    name: 'Campaign 8b',
    startDate: '2026-08-06',
    endDate: '2026-08-07',
    intensity: 'high',
    type: 'campaign',
    channel: 'channel-8',
  },

  // Channel 9 - Dark green campaign from Aug 6 to Aug 7
  {
    id: 'campaign-9-1',
    name: 'Campaign 9',
    startDate: '2026-08-06',
    endDate: '2026-08-07',
    intensity: 'high',
    type: 'campaign',
    channel: 'channel-9',
  },

  // Channel 10 - Light green campaign from Aug 4 to Aug 7
  {
    id: 'campaign-10-1',
    name: 'Campaign 10',
    startDate: '2026-08-04',
    endDate: '2026-08-07',
    intensity: 'low',
    type: 'campaign',
    channel: 'channel-10',
  },
];
